import type React from 'react';
import { isThemePreview } from '../../api/previewVisit';
import { useCommerce } from '../../commerce/ShopCommerce';
import type { PageLine } from '../../commerce/usePageLineCart';
import { checkoutLanguage, languageSubmitText } from '../../components/checkoutLabels';
import { useCodForm } from '../../components/useCodForm';
import { useElementRender } from './elementRenderContext';

// A store whose COD display is POPUP keeps its order form behind a click: the COD page shows an order button
// where the form would be, and Buy it now opens the form over the product instead of leaving for another page.
// The builder and a theme preview keep the form drawn on the page, where a merchant styles it.

// Reports whether this visit keeps the order form in a popup: the store chose it, and this is a live storefront.
export function usePopupCheckout(): boolean {
  const { editing } = useElementRender();
  return useCodForm()?.checkoutDisplay === 'POPUP' && !editing && !isThemePreview();
}

// Draws the button that opens the order form over the page for the page's product alone, leaving the cart untouched.
export const PopupCheckoutButton: React.FC<{ line: PageLine }> = ({ line }) => {
  const commerce = useCommerce();
  const style = useCodForm()?.style;
  if (!commerce) return null;
  // The merchant's own words from Form style, else the store language's.
  const words = style?.openButtonText?.trim() || languageSubmitText(checkoutLanguage(commerce.language, commerce.direction)).orderNowLabel;
  return <button type="button" className="xe-purchase-buy-now xe-checkout-popup" onClick={() => commerce.buyNow(line, false)}>{words}</button>;
};
